import React from "react";

export const UiComponents = () => {
  return (
    <div>
      <div className="hero-articles">
        {" "}
        this own mini-projects have helped me to sharpen my HTML, CSS & JS
        skills✨ pd: no todos son responsive, la mayoría solo solo adaptados a
        dispositivos escritorio
        <div className="container-mini-proyects"></div>
      </div>
    </div>
  );
};

export default UiComponents;
